export default __webpack_public_path__ + "static/media/BackgroundCardHeaderLight.c4d41afb.svg";